/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';

/**
 * 
 * @export
 * @interface ParcDto
 */
export interface ParcDto {
    /**
     * 
     * @type {string}
     * @memberof ParcDto
     */
    id: string;
    /**
     * Numéro de parc unique
     * @type {string}
     * @memberof ParcDto
     */
    reference: string;
    /**
     * Libellé du parc
     * @type {string}
     * @memberof ParcDto
     */
    name: string;
    /**
     * Propriétaire (bailleur) du parc
     * @type {string}
     * @memberof ParcDto
     */
    ownerId: string;
    /**
     * Biens rattachés au parc
     * @type {Array<RealEstateDto>}
     * @memberof ParcDto
     */
    realEstates?: Array<RealEstateDto>;
}

/**
 * Check if a given object implements the ParcDto interface.
 */
export function instanceOfParcDto(value: object): value is ParcDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    return true;
}

export function ParcDtoFromJSON(json: any): ParcDto {
    return ParcDtoFromJSONTyped(json, false);
}

export function ParcDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reference': json['reference'],
        'name': json['name'],
        'ownerId': json['ownerId'],
        'realEstates': json['realEstates'] == null ? undefined : ((json['realEstates'] as Array<any>).map(RealEstateDtoFromJSON)),
    };
}

export function ParcDtoToJSON(json: any): ParcDto {
    return ParcDtoToJSONTyped(json, false);
}

export function ParcDtoToJSONTyped(value?: ParcDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
        'name': value['name'],
        'ownerId': value['ownerId'],
        'realEstates': value['realEstates'] == null ? undefined : ((value['realEstates'] as Array<any>).map(RealEstateDtoToJSON)),
    };
}

